// packages
import { makeStyles } from '@rneui/themed';

export default makeStyles((theme) => ({
  container: {
    width: '100%',
    maxWidth: 500
  },
  inputcontainerStyle: {
    backgroundColor: '#ffff',
    borderRadius: 25,
    height: 80,
    marginTop: 20,
    paddingLeft: 30,
    paddingTop: 15
  },
  inputContainer: {
    borderBottomWidth: 0,
    height: 30
  },
  inputlabelstyle: {
    marginLeft: 5
  },
  buttonContainer: {
    borderRadius: 50,
    marginTop: 20,
    width: '100%'
  },
  bottomHelper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
    paddingHorizontal: 5,
    width: '100%'
  },
  textBottom: {
    color: theme.colors.grey2,
    fontWeight: 'bold'
  }
}));
